import React from "react";
import styled, { css } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faTags,
  faCodeBranch,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import logger from "utils/logger";

const StyledNavbar = styled.nav`
  width: 100%;
  display: flex;
  box-shadow: ${({ theme }) => theme.navbarBoxShadow};
  /* line-height: 1.5; */
  margin-bottom: ${({ mariginBottom }) => mariginBottom};
`;

const StyledUl = styled.ul`
  display: flex;
  column-gap: 10px;
  list-style: none;
  padding-left: 0;
  margin-top: 0;
  margin-bottom: 0;
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)``;

const liVariants = {
  active: css`
    color: ${({ theme }) => theme.black};
    ${StyledFontAwesomeIcon} {
      color: ${({ theme }) => theme.black};
    }
    font-weight: 600;
    border-bottom: 2px solid ${({ theme }) => theme.quoteGray};
  `,
  normal: css`
    ${StyledFontAwesomeIcon} {
      color: #959da5;
    }
    /* 透明的 */
    border-bottom: 2px solid rgba(209, 213, 218, 0);
    :hover {
      border-bottom-color: ${({ theme }) => theme.middleGray};
    }
  `,
};
const StyledLink = styled(Link)`
  color: initial;
  text-decoration: none;
  display: flex;
  align-items: baseline;
  column-gap: 6px;
  cursor: pointer;
`;

const StyledLi = styled.li`
  padding: 8px 16px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial,
    sans-serif, Apple Color Emoji, Segoe UI Emoji;
  font-size: ${({ theme }) => theme.fontSize.lsmall};
  color: ${({ theme }) => theme.black};
  white-space: nowrap;
  border: 0;
  ${({ active }) => (active ? liVariants.active : liVariants.normal)}
  transition: color,border  0.36s ease-in;
`;

// search url search param 字符串
const Navbar = ({ barItems = [], search, mariginBottom = "" }) => {
  const { pathname } = useLocation();
  return (
    <StyledNavbar mariginBottom={mariginBottom}>
      <StyledUl>
        {barItems.map((barItem) => (
          <StyledLi
            key={barItem.basePath}
            active={pathname === barItem.basePath}
          >
            <StyledLink to={`${barItem.basePath}${search}`}>
              <StyledFontAwesomeIcon icon={barItem.icon} size="sm" />
              {barItem.name}
            </StyledLink>
          </StyledLi>
        ))}
      </StyledUl>
    </StyledNavbar>
  );
};

export default Navbar;
